<template>
    <div class="enter-box">
        <img class="enter-img" v-if="enContent==null" src="../../static/image/enterprise/enterprise-header.png">
        <img class="enter-img" v-else :src="enContent.headImage">
        <div class="enter-boxs" id="en-into-corporate">
            <div class="enter-TE">C O M P A N Y &nbsp;&nbsp; P R O F I L E</div>
            <div class="enter-TC">企业介绍</div>
            <el-row>
                <el-col :span="16" :offset="4">
                    <div class="enter-text-box">
                        <div class="enter-interval30"v-if="enContent==null">
                            上海索康医用材料有限公司是一家以科技研发为主导的医用植入材料生产企业。目前，我们的产品包括：人工血管、面部植入物、外科隔离膜（人造硬脑膜、人造硬脊膜），广泛应用于血管外科、神经外科、胸外科、整形美容外科、骨科和普外科等。是纯膨体研发与制造企业，以及亚洲膨体聚四氟乙烯材料的人工血管制造企业。
                        </div>
                        <div class="enter-interval30"v-else>
                            {{enContent.profileText1}}
                        </div>

                        <div class="enter-interval30" v-if="enContent==null">
                            上海索康医用材料有限公司成立于2002年，坐落于中国上海市未来岛园区。在成立以来的17年间，始终致力于“让品质为中国说话”的企业理念，视产品质量为企业生命，严格把控从原材料、生产过程、质量检测到质量追踪的每一个环节。
                        </div>
                        <div class="enter-interval30"v-else>
                            {{enContent.profileText2}}
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="16" :offset="4">
                    <img class="enter-img" v-lazy="Emain[0]" v-if="enContent==null">
                    <img class="enter-img" v-lazy="enContent.profileImage1" v-else>
<!--                    <img class="enter-img" src="../../static/image/enterprise/enterprise-main01.png">-->
                </el-col>
            </el-row>
            <img class="enter-img enter-interval30" v-lazy="Emain[1]" v-if="enContent==null">
            <img class="enter-img enter-interval30" v-lazy="enContent.profileImage2" v-else>
<!--            <img class="enter-img enter-interval30" src="../../static/image/enterprise/enterprise-main02.png">-->
            <el-row>
                <el-col :span="16" :offset="4">
                    <div class="enter-text-box">
                        <div class="enter-interval30" v-if="enContent==null">
                            上海索康医用材料有限公司是膨体聚四氟乙烯面部植入物领域的开拓者，时至今日已经向求美者提供不少于50万件面部植入材料。取得了包括纯膨体、成型鼻假体以及复合型耳支架在内的多项革命性创新成果，并拥有近50项发明及实用新型专利。
                        </div>
                        <div class="enter-interval30" v-else>
                            {{enContent.profileText3}}
                        </div>
                        <div class="enter-interval60" v-if="enContent==null">
                            上海索康医用材料有限公司强化研发力量，扩大生产规模。不断推进医疗事业的向前发展，为我们的合作伙伴、运营机构、患者创造可持续性价值，为社会的进步承担我们的责任、尽到我们的义务，并做出我们的贡献。
                        </div>
                        <div class="enter-interval60" v-else>
                            {{enContent.profileText4}}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div id="en-corporate-history">
            <img class="enter-img" v-lazy="Emain[2]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.developmentHistoryImage" v-else>
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main03.png">-->
        </div>
        <div class="enter-boxs" id="en-corporate-culture">
            <div class="enter-TE">S U O K A N G &nbsp;&nbsp; C U L T U R E</div>
            <div class="enter-TC">索康文化</div>
            <div class="enter-TCC enter-interval30" v-if="enContent==null">让品质为中国说话！</div>
            <div class="enter-TCC enter-interval30" v-else>{{enContent.cultureText1}}</div>
            <div class="enter-text-box">
                <div class="enter-interval60"  v-if="enContent==null">
                    索康以向世界传播健康美丽时尚为己任，把客户对健康美丽的需求作为公司的生存理念，力求成为享誉国际的医用材料供应商
                </div>
                <div class="enter-interval60"  v-else>
                    {{enContent.cultureText2}}
                </div>
            </div>
            <img class="enter-img" v-lazy="Emain[3]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.cultureImage1" v-else>
            <img class="enter-img" v-lazy="Emain[4]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.cultureImage2" v-else>
            <img class="enter-img" v-lazy="Emain[5]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.cultureImage3" v-else>
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main04.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main05.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main06.png">-->
        </div>
        <div class="enter-boxs" id="en-material-history">
            <div class="enter-TE">e - P T F E &nbsp;&nbsp; I N T R O D U C T I O N</div>
            <div class="enter-TC">膨体介绍</div>
            <!--            <el-row>-->
            <!--                <el-col :span="8" :offset="3">-->
            <!--                    <div class="enter-text-box">-->
            <!--                        <div class="enter-text-T enter-interval30">-->
            <!--                            历史-->
            <!--                        </div>-->
            <!--                        <div class="enter-pengti">-->
            <!--                           膨体聚四氟乙烯（expanded Polytetrafluoroethylene，简称e-PTFE）。 1969年，美国科学家Bill Gore发明了第一条膨体聚四氟乙烯人工血管。-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </el-col>-->
            <!--                <el-col :span="4" :offset="4">-->
            <!--                    <img class="enter-img" src="../../static/image/enterprise/enterprise-gongshi.png">-->
            <!--                </el-col>-->
            <!--            </el-row>-->
            <img class="enter-img" v-lazy="Emain[13]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage1" v-else>
            <img class="enter-img" v-lazy="Emain[6]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage2" v-else>
            <img class="enter-img" v-lazy="Emain[8]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage3" v-else>
            <img class="enter-img" v-lazy="Emain[7]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage4" v-else>
            <img class="enter-img" v-lazy="Emain[9]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage5" v-else>
            <img class="enter-img" v-lazy="Emain[14]" v-if="enContent==null">
            <img class="enter-img" v-lazy="enContent.eptftIntroductionImage6" v-else>
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main16.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main07.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main09.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main08.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main10.png">-->
<!--            <img class="enter-img" src="../../static/image/enterprise/enterprise-main17.jpg">-->
            <el-row>
                <el-col :span="16" :offset="4">
<!--                    <img class="enter-img enter-interval60" src="../../static/image/enterprise/enterprise-main11.jpg">-->
                    <img class="enter-img enter-interval60" v-lazy="Emain[10]" v-if="enContent==null">
                    <img class="enter-img enter-interval60" v-lazy="enContent.eptftIntroductionImage7" v-else>
                </el-col>
            </el-row>
        </div>
        <div class="enter-boxs" id="en-production">
<!--            <img class="enter-img enter-TC" src="../../static/image/enterprise/enterprise-main12.png">-->
            <img class="enter-img enter-TC" v-lazy="Emain[11]" v-if="enContent==null">
            <img class="enter-img enter-TC" v-lazy="enContent.developmentImage1" v-else>
            <el-row>
                <el-col :span="16" :offset="4">
                    <div class="enter-text-box">
                        <div class="enter-interval30" v-if="enContent==null">
                            上海索康医用材料有限公司的科研人员正在努力探索膨体在医疗领域应用的新科技、新方法。凭借广泛的人才资源，丰富的医疗研究机构资源，专业的学术带头人资源。我们能够拥有并保持多样性的产品线，同时为全社会不断提供创新产品。
                        </div>
                        <div class="enter-interval30" v-else>
                            {{enContent.developmentText1}}
                        </div>
                        <div class="enter-interval30" v-if="enContent==null">
                            作为亚洲膨体聚四氟乙烯材料的人工血管制造企业，在膨体的医学应用方面，我们持续探索，并不断创新。让我们自豪的是，在叶明董事长（上海交通大学医学学士，上海复旦大学高分子专业硕士）的带领下，我们成功结合医学与材料学的研发力量，独立研发出了无需任何粘结剂的纯膨体技术，一举突破了膨体材料的厚度限制并获得了国家知识产权局颁发的相关专利证书。
                        </div>
                        <div class="enter-interval30" v-else>
                            {{enContent.developmentText2}}
                        </div>
                        <div class="enter-interval60" v-if="enContent==null">
                            上海索康医用材料有限公司深刻理解医疗用品的安全有效是最基本的行业诉求，也是我们所应当承担的最基本的社会责任。从原材料的全球采购、产品生产制造、产品质量检测到产品质量追踪，我们的工程师、生产者时刻追踪每一个对应的环节。在成立的17年来，我们对产品生产全过程的严格监控与高标准实施获得了医疗机构和患者的高度认可。
                        </div>
                        <div class="enter-interval30" v-else>
                            {{enContent.developmentText3}}
                        </div>
                    </div>
                </el-col>
            </el-row>
<!--            <img class="enter-img enter-interval90" src="../../static/image/enterprise/enterprise-main13.png">-->
            <img class="enter-img enter-interval90" v-lazy="Emain[12]" v-if="enContent==null">
            <img class="enter-img enter-interval90" v-lazy="enContent.developmentImage2" v-else>
            <!--            <div class="enter-text-T enter-interval30">具备膨体全产品线独立生产实力</div>-->
            <!--            <div class="enter-text-box">-->
            <!--                <div class="enter-interval60">-->
            <!--                    公司配套有万级洁净车间、检测中心及仓储区域等膨体生产全过程，拥有医用级别的生产能力。-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <img class="enter-img enter-interval90" src="../../static/image/enterprise/enterprise-main14.png">-->

            <!--            <div class="enter-text-T enter-interval30">严格把控产品质量</div>-->
            <!--            <div class="enter-text-box">-->
            <!--                <div class="enter-interval60">-->
            <!--                    索康深知产品品质的重要性，严格把控原料、生产、质检等全过程，确保产品均拥有优良品质。-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <img class="enter-img enter-interval90" src="../../static/image/enterprise/enterprise-main15.png">-->
        </div>
    </div>
</template>

<script>
import Emain1 from "../../static/image/enterprise/enterprise-main01.png"
import Emain2 from "../../static/image/enterprise/enterprise-main02.png"
import Emain3 from "../../static/image/enterprise/enterprise-main03.jpg"
import Emain4 from "../../static/image/enterprise/enterprise-main04.jpg"
import Emain5 from "../../static/image/enterprise/enterprise-main05.jpg"
import Emain6 from "../../static/image/enterprise/enterprise-main06.png"
import Emain7 from "../../static/image/enterprise/enterprise-main07.jpg"
import Emain8 from "../../static/image/enterprise/enterprise-main08.png"
import Emain9 from "../../static/image/enterprise/enterprise-main09.png"
import Emain10 from "../../static/image/enterprise/enterprise-main10.png"
import Emain11 from "../../static/image/enterprise/enterprise-main11.jpg"
import Emain12 from "../../static/image/enterprise/enterprise-main12.png"
import Emain13 from "../../static/image/enterprise/enterprise-main13.jpg"
import Emain14 from "../../static/image/enterprise/enterprise-main16.png"
import Emain15 from "../../static/image/enterprise/enterprise-main17.png"

export default {
  name: 'Enterprise',
  metaInfo: {
    title: '走进索康', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '索康介绍'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的企业级介绍'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      this.getlocal()
    })
    this.$store.dispatch('enterprise/enMessage').then((res) => {
      this.enContent = res
      // console.log(this.enContent)
    })
  },
  data() {
    return {
      Emain: [Emain1,Emain2,Emain3,Emain4,Emain5,Emain6,Emain7,Emain8,Emain9,Emain10,Emain11,Emain12,Emain13,Emain14,Emain15],
      enContent: null
    }
  },
  mounted: function () {
    // let that = this
    // that.$nextTick(function () {
    //   window.addEventListener('scroll' ,that.handleScroll)
    // })
    // console.log("mounted")
  },
  methods: {
    // 从我本地找到id
    getlocal() {
      // 找到锚点id
      let findId = this.$route.query.id
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', findId)
    }
  },
  watch: {
    $route(to, from) {
      // console.log( to , from )
      // console.log(to.query.id)
      //  to , from 分别表示从哪跳转到哪，都是一个对象
      // to.path   ( 表示的是要跳转到的路由的地址 eg:  /home );
      // to.query.id 提取id进行http请求数据更新页面
      this.$store.dispatch('method/anchorPoint', to.query.id)
    }
  }
}
</script>

<style scoped>
    .enter-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        width: 100%;
    }

    .enter-img {
        width: 100%;
    }

    .enter-TE {
        font-family: Futura-LT-Book;
        color: #430098;
        font-size: 25px;
        margin: 100px 0 10px 0;
    }

    .enter-TC {
        font-family: SY-Normal;
        font-size: 20px;
        color: #430098;
        margin-bottom: 50px;
    }

    .enter-text-box {
        font-family: SY-Light;
        font-size: 14px;
        color: #4d4d4d;
        line-height: 35px
    }

    .enter-boxs {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .enter-TCC {
        font-family: SY-Normal;
        font-size: 30px;
        color: #4d4d4d;
    }

    .enter-interval30 {
        margin-bottom: 30px;
    }

    .enter-interval60 {
        margin-bottom: 60px;
    }

    .enter-interval90 {
        margin-bottom: 90px;
    }

    .el-row {
        width: 100%;
    }

    .enter-text-T {
        font-family: SY-Normal;
        font-size: 23px;
        color: #4d4d4d;
    }

    .enter-pengti {
        font-family: SY-Light;
        font-size: 14px;
        color: #4d4d4d;
    }
</style>
